import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class UnitHasUsersModel extends BaseModel {

    constructor() {
        super({
                name: "unit_has_users",
                tableName: 'unit_has_users',
                label: "Quản Lý Unit",
            },
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    // display: { list: true, add: false, edit: false }
                },
                id: {
                    name: "id",
                    display: false
                },
                unit_id: { 
                    name: 'unit_id',
                    display: false
                },
                user_id: { 
                    name: 'user_id',
                    display: false
                }

            },
            )
    }

}